﻿import { EnumEditor, DateTimeEditor, IntegerEditor, LookupEditor, StringEditor, PrefixedContext, initFormType } from "@serenity-is/corelib";
import { DataAuditLogType } from "./DataAuditLog.DataAuditLogType";

export interface DataAuditLogForm {
    LogType: EnumEditor;
    LogDate: DateTimeEditor;
    UserId: IntegerEditor;
    Tablename: LookupEditor;
    RecordId: StringEditor;
    FieldName: LookupEditor;
    OldValue: StringEditor;
    NewValue: StringEditor;
}

export class DataAuditLogForm extends PrefixedContext {
    static readonly formKey = 'Serenity.Pro.DataAuditLog.DataAuditLogForm';
    private static init: boolean;

    constructor(prefix: string) {
        super(prefix);

        if (!DataAuditLogForm.init)  {
            DataAuditLogForm.init = true;

            var w0 = EnumEditor;
            var w1 = DateTimeEditor;
            var w2 = IntegerEditor;
            var w3 = LookupEditor;
            var w4 = StringEditor;

            initFormType(DataAuditLogForm, [
                'LogType', w0,
                'LogDate', w1,
                'UserId', w2,
                'Tablename', w3,
                'RecordId', w4,
                'FieldName', w3,
                'OldValue', w4,
                'NewValue', w4
            ]);
        }
    }
}

[DataAuditLogType]; // referenced types